import { render, staticRenderFns } from "./RenuevePassword.vue?vue&type=template&id=140dc97e&"
import script from "./RenuevePassword.vue?vue&type=script&lang=js&"
export * from "./RenuevePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports